// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_g1-3";
export var flatBottomCorners = "_g1-5";
export var productImage = "_g1-0";
export var quantityContainer = "_g1-2";
export var quantityHeader = "_g1-6";
export var tooltip = "_g1-1";
export var wrapAndEllipsesOverflow = "_g1-4";